import type { Dayjs } from "dayjs"

/**
 * Combines a date-only picker value with a time-of-day value into the one
 * instant the composer actually schedules. `time` already carries the
 * correct absolute hour — `CustomTimePicker`'s `use12Hours` clock resolves
 * AM/PM into the real 24-hour value itself, so there is nothing left for the
 * caller to reapply here.
 */
function combineScheduledFor(date: Dayjs, time: Dayjs): Dayjs {
  return date.hour(time.hour()).minute(time.minute()).second(0).millisecond(0)
}

export { combineScheduledFor }
